__turbopack_context__.v({
  "check": "locality-filter-module__B-JiSG__check",
  "inputWpr": "locality-filter-module__B-JiSG__inputWpr",
  "km": "locality-filter-module__B-JiSG__km",
  "list": "locality-filter-module__B-JiSG__list",
  "loader": "locality-filter-module__B-JiSG__loader",
  "loaderWpr": "locality-filter-module__B-JiSG__loaderWpr",
  "locality": "locality-filter-module__B-JiSG__locality",
  "noSuggest": "locality-filter-module__B-JiSG__noSuggest",
  "placeholder": "locality-filter-module__B-JiSG__placeholder",
  "selectedLabel": "locality-filter-module__B-JiSG__selectedLabel",
  "selectedList": "locality-filter-module__B-JiSG__selectedList",
  "selectedLocalities": "locality-filter-module__B-JiSG__selectedLocalities",
  "selectedLocality": "locality-filter-module__B-JiSG__selectedLocality",
  "sliderWpr": "locality-filter-module__B-JiSG__sliderWpr",
  "wrapper": "locality-filter-module__B-JiSG__wrapper",
});
